export const SET_PAGE                   = 'SET_PAGE';
export const SET_MODAL                  = 'SET_MODAL';
export const SET_COLOR_MODAL            = 'SET_COLOR_MODAL';
export const SET_SELECTED_URL           = 'SET_SELECTED_URL';
export const SET_SHOW_REVIEW_RESULT     = 'SET_SHOW_REVIEW_RESULT';
export const SET_RETARGETING_CLOSE      = 'SET_RETARGETING_CLOSE';
